module.exports = __webpack_public_path__ + "img/smile-gray.c37b288c.png";